// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CWOZ","col":"styles_col__1Tm5e"};